import { render, staticRenderFns } from "./KanbanItem.vue?vue&type=template&id=3f1905ee&scoped=true"
import script from "./KanbanItem.vue?vue&type=script&lang=js"
export * from "./KanbanItem.vue?vue&type=script&lang=js"
import style0 from "./KanbanItem.vue?vue&type=style&index=0&id=3f1905ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1905ee",
  null
  
)

export default component.exports